<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="profile-content">
      <div>
        <p>个人信息</p>
        <span>请您如实填写以下信息，以便获取更优质的服务！</span>
        <span style="float: right;"><a @click="changePasswd">修改密码</a></span>
      </div>

      <a-form @submit="handleSubmit" :autoFormCreate="formCreateHandle" style="margin: 30px 0;">
        <a-row>
          <a-col :span="12">
            <a-form-item label='注册账号' fieldDecoratorId="userName">
              <a-input disabled />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label='昵称' fieldDecoratorId="nickName" :fieldDecoratorOptions="{rules:[{required:true,message:'昵称不能为空'}]}">
              <a-input />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label='公司名称' fieldDecoratorId="company" :fieldDecoratorOptions="{rules:[{required:true,message:'公司名称不能为空'}]}">
              <a-input />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label='英文名称' fieldDecoratorId="enName" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'英文名称不能为空'}]}||{}">
              <a-input />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label='公司邮箱' fieldDecoratorId="email" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'公司邮箱不能为空'}]}||{}">
              <a-input />
            </a-form-item>
          </a-col>
          <a-col :span="12" class="phone">
            <a-form-item label='固定电话' fieldDecoratorId="areaCode" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'区号不能为空'}]}||{}">
              <a-input style="width:80px;" />
            </a-form-item>
            <a-form-item fieldDecoratorId="phone" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'固定电话不能为空'}]}||{}">
              <a-input style="width:160px;" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-item label='所在的行业' fieldDecoratorId="bigIndustryId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'行业不能为空'}]}||{}">

              <a-select style="width: 120px" @change="changeIndustry" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in industryList" :key="i">{{v.name}}</a-select-option>
              </a-select>

            </a-form-item>
            <a-form-item fieldDecoratorId="industryId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'行业不能为空'}]}||{}">

              <a-select style="width: 120px" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in subIndustryList" :key="i">{{v.name}}</a-select-option>
              </a-select>

            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label='出口产品' fieldDecoratorId="exportProduct" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'出口产品不能为空'}]}||{}">

              <a-input></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">

            <a-form-item label='意向出口国' fieldDecoratorId="exportContinentId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'意向出口国不能为空'}]}||{}">

              <a-select style="width: 120px" @change="changeContinent" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in continentList" :key="i">{{v.cname}}</a-select-option>
              </a-select>

            </a-form-item>
            <a-form-item fieldDecoratorId="exportCountryId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'意向出口国不能为空'}]}||{}">

              <a-select style="width: 120px" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in countryList" :key="i">{{v.cname}}</a-select-option>
              </a-select>

            </a-form-item>

          </a-col>
          <a-col :span="12">
            <a-form-item label='邮编' fieldDecoratorId="postcode" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'邮编不能为空'}]}||{}">
              <a-input />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-item label='联系地址' fieldDecoratorId="provinceId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'联系地址不能为空'}]}||{}">
              <a-select style="width: 120px" @change="changeProvince" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in provinceList" :key="i">{{v.name}}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item fieldDecoratorId="cityId" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'联系地址不能为空'}]}||{}">
              <a-select style="width: 120px" placeholder="请选择">
                <a-select-option :value="v.id" v-for="(v,i) in cityList" :key="i">{{v.name}}</a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item fieldDecoratorId="address" :fieldDecoratorOptions="accountInfo.interest=='registeredPlus'&&{rules:[{required:true,message:'联系地址不能为空'}]}||{}">
              <a-input style="width: 466px" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-button type='primary' style="margin-left: 125px;border-radius: 0;width:120px" size="large" @click="saveProfile">保存</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </a-layout-content>
</template>
<script>
import Banner from "./banner";
import ChPasswd from "./ChPasswd";
export default {
  data() {
    return {
      formLayout: "horizontal",
      industryList: [],
      subIndustryList: [],
      continentList: [],
      countryList: [],
      provinceList: [],
      cityList: [],
      profile: {}
    };
  },
  computed: {
    accountInfo() {
      return this.$store.state.accountInfo;
    }
  },
  created() {},
  methods: {
    changePasswd(){
      this.$dialog(ChPasswd)
    },
    saveProfile() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http.post("/zzUserDetailEdit", values).then(res => {
            if (!res.error) {
              this.$message.success("保存成功");
              this.$refreshAccountInfo();
            } else {
              this.$message.error(res.errorMsg);
              console.log(res);
            }
          });
        }
      });
    },
    formCreateHandle(form) {
      this.form = form;
      this.$http.post("/zzUserDetail").then(res => {
        if (!res.error) {
          this.profile = res.data.detail;
          console.log(this.profile);
          form.setFieldsValue({
            userName: this.profile.userName,
            nickName: this.profile.nickName,
            company: this.profile.company,
            enName: this.profile.enName,
            email: this.profile.email,
            areaCode: this.profile.areaCode,
            phone: this.profile.phone,
            postcode: this.profile.postcode,
            cityId: this.profile.cityId,
            provinceId: this.profile.provinceId,
            address: this.profile.address,
            exportProduct: this.profile.exportProduct
          });

          this.loadContinentList(() => {
            this.profile.exportContinentId &&
              form.setFieldsValue({
                exportContinentId: this.profile.exportContinentId
              });

            this.profile.exportCountryId &&
              this.loadCountryList(this.profile.exportContinentId, res => {
                this.profile.exportCountryId &&
                  form.setFieldsValue({
                    exportCountryId: this.profile.exportCountryId
                  });
              });
          });

          this.loadIndustry(0, res => {
            this.industryList = res;

            this.profile.bigIndustryId &&
              form.setFieldsValue({
                bigIndustryId: this.profile.bigIndustryId
              });

            this.profile.bigIndustryId &&
              this.loadIndustry(this.profile.bigIndustryId, res => {
                this.subIndustryList = res;
                this.profile.industryId &&
                  form.setFieldsValue({
                    industryId: this.profile.industryId
                  });
              });
          });

          this.loadProvinceList(() => {
            form.setFieldsValue({
              provinceId: this.profile.provinceId
            });

            this.loadCityList(this.profile.provinceId, () => {
              form.setFieldsValue({
                cityId: this.profile.cityId
              });
            });
          });
        }
      });
    },
    changeIndustry(v) {
      console.log("changeIndustry");
      this.loadIndustry(v, res => {
        this.subIndustryList = res;
      });
    },
    changeProvince(v) {
      this.loadCityList(v, () => {});
    },
    changeContinent(v) {
      this.loadCountryList(v);
    },
    loadContinentList(cb) {
      this.$http.post("/continentList").then(res => {
        if (!res.error) {
          this.continentList = res.data.continentList;
          cb && cb(this.continentList);
        }
      });
    },
    loadCountryList(continentId, cb) {
      this.$http.post("/countryList", { continentId }).then(res => {
        if (!res.error) {
          this.countryList = res.data.countryList;
          cb && cb(this.countryList);
        }
      });
    },
    loadProvinceList(cb) {
      this.$http.post("/provinceList").then(res => {
        if (!res.error) {
          this.provinceList = res.data.provinceList;
          cb && cb(res.data.provinceList);
        }
      });
    },
    loadCityList(provinceId, cb) {
      this.$http.post("/cityList", { provinceId }).then(res => {
        if (!res.error) {
          this.cityList = res.data.cityList;
          cb && cb(res.data.cityList);
        }
      });
    },
    loadIndustry(parentId, cb) {
      this.$http.post("/industryList", { parentId }).then(res => {
        if (!res.error) {
          cb(res.data.industry);
        }
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    }
  },
  components: { "s-banner": Banner }
};
</script>
<style lang="scss" >
.profile-content {
  min-height: 750px;
  .ant-form {
    .ant-form-item-label {
      width: 120px;
    }
    .ant-select-selection {
      border-radius: 0;
    }
    .ant-select,
    input {
      width: 250px;
      margin: 0 5px;
    }

    .phone > .ant-form-item > .ant-form-item-control-wrapper {
      //  &:first input{
      // background: red;
      //   }
      //   &:last input{
      //   background:blue;
      //   }
    }
  }
}
</style>
<style lang="scss" scoped>
.profile-content {
  & > div:first-child {
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 15px;
    p {
      color: #333;
      font-size: 18px;
      margin-bottom: 5px;
    }
    span {
      color: #999;
      font-size: 13px;
    }
  }
  .ant-form {
    input {
      border-radius: 0;
    }
    & > .ant-row > div,
    .ant-form-item,
    .ant-row {
      display: flex;
    }
  }
}
</style>